import { createReducer, on } from '@ngrx/store';

import { Catalog, DataProduct } from '@mtna/pojo-consumer-ui';

import { RdsDataProductActions, RdsDataProductApiActions } from '../actions';

export interface State {
  hasMultipleDataProducts: boolean;
  initializing: boolean;
  loadingNumberOfVariables: boolean;
  loadingRootCatalog: boolean;
  numberOfVariables: number | null;
  rootCatalog: Catalog;
  selected: DataProduct | null;
}

export const initialState: State = {
  hasMultipleDataProducts: false,
  initializing: true,
  loadingNumberOfVariables: false,
  loadingRootCatalog: false,
  numberOfVariables: null,
  rootCatalog: null,
  selected: null
};

export const reducer = createReducer(
  initialState,
  on(RdsDataProductActions.getRootCatalog, state => ({ ...state, loadingRootCatalog: true })),
  on(RdsDataProductApiActions.getRootCatalogFailure, state => ({
    ...state,
    loadingRootCatalog: false,
    rootCatalog: null,
    hasMultipleDataProducts: false
  })),
  on(RdsDataProductApiActions.getRootCatalogSuccess, (state, { catalog }) => ({
    ...state,
    loadingRootCatalog: false,
    rootCatalog: catalog,
    hasMultipleDataProducts: _getNumberOfDataProducts(catalog) > 1 || state.hasMultipleDataProducts
  })),

  on(RdsDataProductActions.getVariableCount, state => ({ ...state, loadingNumberOfVariables: true, numberOfVariables: null })),
  on(RdsDataProductApiActions.getVariableCountFailure, state => ({ ...state, loadingNumberOfVariables: false, numberOfVariables: null })),
  on(RdsDataProductApiActions.getVariableCountSuccess, (state, { numberOfVariables }) => ({
    ...state,
    loadingNumberOfVariables: false,
    numberOfVariables
  })),

  on(RdsDataProductActions.selectDataProduct, (state, { catalogId, dataProductId }) => {
    if (!!catalogId && !!dataProductId) {
      const selectedCatalog = state.rootCatalog.catalogs.find(cat => catalogId === cat.id);
      const selectedDataProduct = selectedCatalog.dataProducts.find(dp => dp.id === dataProductId);
      return { ...state, initializing: false, selected: selectedDataProduct };
    }
    return { ...state, initializing: false };
  }),
  on(RdsDataProductActions.initialized, state => ({ ...state, initializing: false }))
);

export const hasMultipleDataProducts = (state: State) => state.hasMultipleDataProducts;
export const isInitializing = (state: State) => state.initializing;
export const isLoadingNumberOfVariables = (state: State) => state.loadingNumberOfVariables;
export const isLoadingRootCatalog = (state: State) => state.loadingRootCatalog;
export const getNumberOfVariables = (state: State) => state.numberOfVariables;
export const getRootCatalog = (state: State) => state.rootCatalog;
export const getSelected = (state: State) => state.selected;

function _getNumberOfDataProducts(rootCatalog: Catalog): number {
  if (!rootCatalog || !rootCatalog.catalogs) {
    return 0;
  }
  const counts = rootCatalog.catalogs.filter(cat => !!cat.dataProducts).map(cat => cat.dataProducts.length);
  return !!counts && counts.length ? counts.reduce((total, next) => total + next, 0) : 0;
}
